import { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'

export default function ScrollToTop() {
  const { t } = useTranslation('common')
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const handleScroll = () => setVisible(window.scrollY > 400)
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  if (!visible) return null

  return (
    <button
      onClick={scrollToTop}
      className="fixed bottom-6 right-6 z-40 w-11 h-11 rounded-full bg-primary-500 text-background-50 flex items-center justify-center shadow-lg hover:bg-primary-600 transition-all duration-300 animate-bounce cursor-pointer"
      title={t('scrollToTop')}
    >
      <i className="ri-arrow-up-line text-lg"></i>
    </button>
  )
}